module.exports = __webpack_public_path__ + "static/media/lipikar.2ecc5f71.png";